<template>
  <div class="section-showtime">
    <!--Start Banner Slider--->
    <section class="section-banner simple-banner">
      <slick
        v-if="all_fetched_movies.length > 0"
        ref="bannerSlider"
        :options="bannerSlider"
      >
        <div
          v-for="(data, index) in bannerFromPagesCMS"
          :key="index"
          class="w-100 banner-slider"
        >
          <div class="banner-img">
            <div>
              <img
                :alt="data"
                :src="checkBaseUrl(data)"
                class="image"
                onerror="javascript:this.src='/static/img/default-banner.jpg'"
              />
            </div>
          </div>
        </div>
      </slick>
    </section>
    <!--End Banner Slider--->

    <div class="container">
      <div class="mt-lg-4 mt-3">
        <div class="main-heading">
          <div>
            <hr class="primary-line" />
          </div>
          <div class="title">{{ header }}</div>
        </div>
        <div class="content mb-4">
          <div class="content-title my-3">{{ header1 }}</div>
          <div class="content-desc">
            {{ description }}
          </div>
        </div>
      </div>
    </div>
    <div class="container px-0">
      <div class="mb-4 pb-2">
        <!--Start date Slider
        <div class="date-slider empire-slider px-md-4 py-3">
          <slick ref="dateSlider" :options="dateSlider">
            <div
              v-for="(dateInfo, dateKey) in showAllDateList"
              :key="dateKey"
              v-on:click="scheduleDateMovie(dateInfo.showdate, '1')"
            >
              <div
                class="date-card"
                :class="
                  finalSelectedDate == dateInfo.showdate
                    ? 'date-card-active'
                    : ''
                "
              >
                <div class="month">{{ dateInfo.month }}</div>
                <div class="date py-1">{{ dateInfo.date }}</div>
                <div class="day">{{ dateInfo.day }}</div>
              </div>
            </div>
          </slick>
        </div>
        -->
        <div class="date-slider empire-slider px-md-4 py-3">
          <slick ref="dateSlider2" :options="dateSlider">
            <div
              v-for="(dateInfo, dateKey) in dateList"
              :key="dateKey"
              v-on:click="scheduleDateMovie(dateInfo.ss_actual_start_date, '1')"
            >
              <div
                class="date-card"
                :class="
                  finalSelectedDate == '' && dateKey == 0
                    ? 'date-card-active'
                    : finalSelectedDate == dateInfo.ss_actual_start_date
                    ? 'date-card-active'
                    : ''
                "
              >
                <div class="month">
                  {{
                    moment(dateInfo.ss_actual_start_date)
                      .locale(getCurrentLang().iso_2 ? getCurrentLang().iso_2 : 'en')
                      .format('MMM')
                  }}
                </div>
                <div class="date py-1">
                  {{
                    moment(dateInfo.ss_actual_start_date)
                      .locale(getCurrentLang().iso_2 ? getCurrentLang().iso_2 : 'en')
                      .format('DD')
                  }}
                </div>
                <div class="day">
                  {{
                    moment(dateInfo.ss_actual_start_date)
                      .locale(getCurrentLang().iso_2 ? getCurrentLang().iso_2 : 'en')
                      .format('ddd')
                  }}
                </div>
              </div>
            </div>
          </slick>
        </div>
        <!--End date Slider-->
        <!--Start QuickBook--->
        <div class="row emp-quickbook mx-0">
          <div class="col-md-10">
            <div
              class="
                row
                align-items-center
                mt-n1
                mx-0
                px-0
                py-3
                animate__animated animate__fadeInDown
              "
            >
              <div class="col-xl-3 col-lg-6 col-md-6 px-1 mb-2 mb-xl-0">
                <multiselect
                  v-model="selectedCinemaValues"
                  :options="confirmedMovie.CinemaArray"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :placeholder="allLanguageData.QuickBook.selectCinema"
                  :custom-label="getCinemaTranslatedName"
                  track-by="cinema_id"
                  :select-label="''"
                  :deselect-label="''"
                  :selectedLabel="''"
                  class="custom-multiselect no-scroll"
                >
                  <template slot="selection" slot-scope="{ values, search, isOpen }">
                    <span
                      class="multiselect__single"
                      v-if="values.length>1 && values.length &amp;&amp; !isOpen"
                      >{{ values.length }} Cinemas</span
                    >
                    <span
                      class="multiselect__single"
                      v-else-if=" values.length &amp;&amp; !isOpen"
                      >{{
                        getCinemaTranslatedName(values[0]) || values[0].cinema_name
                      }}</span
                    >
                  </template>
                </multiselect>
                <!-- <b-dropdown
                  variant="default"
                  class="quickbook-dropdown"
                  text="Select Cinema"
                >
                  <b-dropdown-item v-for="(data, Index) in 10" :key="Index"
                    >Cinema One</b-dropdown-item
                  >
                </b-dropdown> -->
              </div>

              <div class="col-xl-3 col-lg-6 col-md-6 px-1 mb-2 mb-xl-0">
                <multiselect
                  v-model="selectedMovie"
                  :options="all_fetched_movies"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :placeholder="allLanguageData.QuickBook.selectMovie"
                  label="movie_title"
                  track-by="movie_id"
                  class="custom-multiselect scroll-dropdown"
                  :select-label="''"
                  :deselect-label="''"
                  :selectedLabel="''"
                >
                  <template slot="selection" slot-scope="{ values, search, isOpen }"
                    ><span
                      class="multiselect__single"
                      v-if="values.length > 1 &amp;&amp; !isOpen"
                      >{{ values.length }} Movie</span
                    >
                    <span
                      class="multiselect__single"
                      v-else-if="values.length &amp;&amp; !isOpen"
                      >{{ values[0].movie_title }}</span
                    >
                  </template>
                </multiselect>
                <!-- <b-dropdown
                  variant="default"
                  class="quickbook-dropdown scroll-dropdown"
                  text="Select Movie"
                >
                  <b-dropdown-item v-for="(data, Index) in 10" :key="Index"
                    >Movie One</b-dropdown-item
                  >
                </b-dropdown> -->
              </div>
              <div class="col-xl-3 col-lg-6 col-md-6 px-1 mb-2 mb-xl-0">
                <multiselect
                  v-model="selectedExpValues"
                  :options="confirmedMovie.FormatArray"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :placeholder="allLanguageData.QuickBook.selectExp"
                  label="mf_name"
                  track-by="mf_id"
                  :select-label="''"
                  :deselect-label="''"
                  :selectedLabel="''"
                  class="custom-multiselect scroll-dropdown experience-dropdown"
                >
                  <template slot="selection" slot-scope="{ values, search, isOpen }"
                    ><span
                      class="multiselect__single"
                      v-if="values.length > 1 &amp;&amp; !isOpen"
                      >{{ values.length }} Experience</span
                    >
                    <span
                      class="multiselect__single"
                      v-else-if="values.length &amp;&amp; !isOpen"
                      >{{ values[0].mf_name }}</span
                    >
                  </template>
                </multiselect>
                <!-- <b-dropdown
                  variant="default"
                  class="quickbook-dropdown"
                  text="Select Experience"
                >
                  <b-dropdown-item v-for="(data, Index) in 10" :key="Index"
                    >Experience One</b-dropdown-item
                  >
                </b-dropdown> -->
              </div>
              <div class="col-xl-3 col-lg-6 col-md-6 px-1">
                <multiselect
                  v-model="selectedShowTimes"
                  :options="confirmedMovie.sessions"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :placeholder="allLanguageData.QuickBook.selectShowTimes"
                  label="label"
                  track-by="label"
                  class="custom-multiselect scroll-dropdown"
                  :select-label="''"
                  :deselect-label="''"
                  :selectedLabel="''"
                >
                  <template slot="selection" slot-scope="{ values, search, isOpen }"
                    ><span
                      class="multiselect__single"
                      v-if="values.length > 1&amp;&amp; !isOpen"
                      >{{ values.length }} Time</span
                    >
                    <span
                      class="multiselect__single"
                      v-else-if="values.length &amp;&amp; !isOpen"
                      >{{ values[0].label }}</span
                    >
                  </template>
                </multiselect>
                <!-- <b-dropdown
                  variant="default"
                  class="quickbook-dropdown"
                  text="ShowTimes"
                >
                  <b-dropdown-item v-for="(data, Index) in 10" :key="Index"
                    >09th June</b-dropdown-item
                  >
                </b-dropdown> -->
              </div>
            </div>
          </div>
          <div class="col-md-2 mb-3 mb-md-0 show-view">
            <div
              v-on:click="showView('list')"
              v-bind:class="langName == 'ar' ? 'border-left pl-2' : 'border-right pr-2'"
            >
              <div :class="listView ? 'view-active' : ''">
                <svg viewBox="0 0 18.23 21.56">
                  <line class="cls-1" x1="18.23" y1="1.54" x2="5.04" y2="1.54" />
                  <line class="cls-1" x1="18.23" y1="7.98" x2="5.04" y2="7.98" />
                  <line class="cls-1" x1="18.23" y1="13.47" x2="5.04" y2="13.47" />
                  <line class="cls-1" x1="18.23" y1="19.92" x2="5.04" y2="19.92" />
                  <ellipse class="cls-1" cx="1.74" cy="1.78" rx="1.24" ry="1.28" />
                  <ellipse class="cls-1" cx="1.74" cy="7.78" rx="1.24" ry="1.28" />
                  <ellipse class="cls-1" cx="1.74" cy="13.78" rx="1.24" ry="1.28" />
                  <ellipse class="cls-1" cx="1.74" cy="19.77" rx="1.24" ry="1.28" />
                </svg>
              </div>
            </div>
            <div
              v-bind:class="langName == 'ar' ? 'pr-2' : 'pl-2'"
              v-on:click="showView('grid')"
            >
              <div :class="gridView ? 'view-active' : ''">
                <svg viewBox="0 0 18.3 19.62">
                  <rect class="cls-1" x="0.25" y="0.25" width="7.25" height="7.25" />
                  <rect class="cls-1" x="0.25" y="12.12" width="7.25" height="7.25" />
                  <rect class="cls-1" x="10.8" y="0.25" width="7.25" height="7.25" />
                  <rect class="cls-1" x="10.8" y="12.12" width="7.25" height="7.25" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <!---End QuickBook--->
      </div>
    </div>
    <div class="container px-lg-0">
      <!--Desktop View--->
      <div class="row emp-showtimes mx-0 mb-5 d-none d-md-block" v-if="listView">
        <div
          class="col-md-12 showtime-list mx-0"
          v-for="(data, index) in filteredFlattenedSchedule"
          :key="index"
        >
          <div class="row mx-0 d-flex align-items-center pt-4 pb-3">
            <div class="col-md-2 px-0">
              {{
                getCinemaTranslatedName(data.schedules[0].cinema) ||
                  data.schedules[0].cinema_name
              }}
            </div>
            <div class="col-md-3 grid-half align-items-center">
              <div class="movie-img">
                <img
                  v-if="getMovieData(data, 'artwork')"
                  :src="getMovieData(data, 'artwork')"
                  class="image img-fluid"
                  onerror="javascript:this.src='/static/img/default-Img.png'"
                />
                <img
                  v-else
                  src="@/assets/img/new-img/png-img/default-Img.png"
                  class="image img-fluid"
                />
              </div>
              <div v-bind:class="langName == 'ar' ? 'pr-4' : 'pl-3'">
                {{ getMovieData(data, 'movie_title') }}
              </div>
            </div>
            <div class="col-md-2 ar-number">
              <div>
                {{ data.mf_names }} -
                {{
                  movieLanguagesWithSubs(
                    data.schedules[0].lang_name,
                    data.schedules[0].sub_lang_1_iso_2,
                    data.schedules[0].sub_lang_2_iso_2,
                  )
                }}
              </div>
            </div>
            <div class="col-md-5 px-0">
              <ul class="list-inline-item showtimes__time-tag w-100">
                <li
                  class="time-tag list-inline-item"
                  :class="[schedule.showTime]"
                  v-for="(schedule, indexTime) in data.schedules"
                  :key="indexTime"
                  v-b-modal.contactcinemapopup
                  @click="seatLayoutShowBrij(schedule, data)"
                  v-b-tooltip.hover
                  :title="
                    `${schedule.screen_name}${
                      schedule.mf_name ? ` - ${schedule.mf_name}` : ''
                    }${
                      schedule.show_timing_label
                        ? ` - ${
                            schedule.isPrevDayAmShow
                              ? 'Early Morning'
                              : schedule.isNextDayAmShow
                              ? `${allLanguageData.AfterMidnight}`
                              : schedule.show_timing_label
                          }`
                        : ''
                    }`
                  "
                >
                  <router-link to
                    >{{
                      moment(schedule.showTime, ['HH.mm'])
                        .locale(getCurrentLang().iso_2 || 'en')
                        .format('hh:mm A')
                    }}
                  </router-link>
                </li>

                <div
                  class="d-flex justify-center justify-content-center align-items-center align-content-center"
                  style="min-width: 275px;"
                  v-if="data.schedules_after_midnight.length > 0"
                >
                  <div style="width: 36%">
                    <hr />
                  </div>
                  <span
                    class="d-flex justify-center justify-content-center align-items-center align-content-center px-2 font-weight-light"
                    style="flex-direction: row;"
                  >
                    {{ allLanguageData.AfterMidnight }}
                  </span>
                  <div style="width: 36%">
                    <hr />
                  </div>
                </div>

                <li
                  class="time-tag list-inline-item"
                  :class="[schedule.showTime]"
                  v-for="(schedule, indexTime) in data.schedules_after_midnight"
                  :key="indexTime"
                  @click="seatLayoutShowBrij(schedule, data)"
                  v-b-tooltip.hover
                  :title="
                    `${schedule.screen_name}${
                      schedule.mf_name ? ` - ${schedule.mf_name}` : ''
                    }${
                      schedule.show_timing_label
                        ? ` - ${
                            schedule.isPrevDayAmShow
                              ? 'Early Morning'
                              : schedule.isNextDayAmShow
                              ? `${allLanguageData.AfterMidnight}`
                              : schedule.show_timing_label
                          }`
                        : ''
                    }`
                  "
                >
                  <router-link to
                    >{{
                      moment(schedule.showTime, ['HH.mm'])
                        .locale(getCurrentLang().iso_2 || 'en')
                        .format('hh:mm A')
                    }}
                  </router-link>
                </li>
              </ul>

              <!-- <ul class="d-flex flex-wrap showtimes__time-tag ">
                <li
                  class="time-tag"
                  v-for="(dataTime, indexTime) in data.show_time"
                  :key="indexTime"
                  @click="seatLayoutShow(dataTime, data)"
                  v-b-tooltip.hover
                  :title="dataTime.ScreenName"
                >
                  <router-link to class="text-white">{{
                    dataTime.time
                  }}</router-link>
                </li>
              </ul> -->
            </div>
          </div>
          <div class="row showtime-line">
            <img
              src="@/assets/img/new-img/svg-img/vertical-line.svg"
              class="image img-fluid"
            />
          </div>
        </div>
        <div v-if="allCinemas.length <= 0">
          <div class="no-shows-found">
            {{ isMovies }}
          </div>
        </div>
        <b-button
          v-if="loadPageNo < paginationCountdata && allCinemas.length > 0"
          @click="onLoadMore"
          class="btn-load-more mt-3"
          >{{ allLanguageData.LoadMore }}
        </b-button>
      </div>
      <div class="emp-showtimes mx-0 mb-5" v-if="gridView" style="min-height: 300px">
        <div
          style="min-height: 300px"
          v-if="moviesLoading"
          class="offer-scroll-box d-flex align-items-center justify-content-center"
        >
          <h6 class="text-center text-muted my-5">
            <div class="spinner-border"></div>
          </h6>
        </div>

        <MovieSlider
          v-else
          isShowTime="Yes"
          :key="componentKeySlider"
          bgcolor="emp-bgsecondary"
          oppbgcolor="emp-bgprimary"
          booknow="true"
          :moviesArray="filteredMovies"
          @changeMviFilter="ChangeM($event)"
        />
        <div
          v-if="filteredMovies.length === 0"
          class="offer-scroll-box d-flex align-items-center justify-content-center"
          style="min-height: 300px"
        >
          <h6 class="text-center text-muted my-5">
            {{ ' ' }}
          </h6>
        </div>
      </div>
      <!--End Desktop View-->
      <!--Start Mobile View--->
      <div class="row emp-showtimes mx-0 mb-5 d-block d-md-none" v-if="listView">
        <div
          v-if="listView && filteredFlattenedSchedule.length > 0"
          class="col-md-12 showtime-list mx-0"
          v-for="(data, index) in filteredFlattenedSchedule"
          :key="index"
        >
          <div class="row mx-0 py-3">
            <div class="col-12 title pl-0">
              {{ data.mf_names }} -
              {{
                movieLanguagesWithSubs(
                  data.schedules[0].lang_name,
                  data.schedules[0].sub_lang_1_iso_2,
                  data.schedules[0].sub_lang_2_iso_2,
                )
              }}
            </div>
            <!-- <div class="col-4">
              <div class="movie-img">
                <img
                  src="@/assets/img/new-img/jpg-img/movieimg.jpg"
                  class="img-fluid"
                />
              </div>
            </div> -->
            <div class="col-12 pl-0">
              <div class="title pb-1">
                {{ getMovieData(data, 'movie_title') }}
              </div>
              <div>
                {{
                  getCinemaTranslatedName(data.schedules[0].cinema) ||
                    data.schedules[0].cinema_name
                }}
              </div>
              <div class="pt-2">
                <ul class="list-inline">
                  <li
                    class="list-inline-item time-tag"
                    :class="[schedule.showTime]"
                    v-for="(schedule, indexTime) in data.schedules"
                    :key="indexTime"
                    @click="seatLayoutShowBrij(schedule, data)"
                  >
                    <router-link to
                      >{{
                        moment(schedule.showTime, ['HH.mm'])
                          .locale(getCurrentLang().iso_2 || 'en')
                          .format('hh:mm A')
                      }}
                    </router-link>
                  </li>

                  <div
                    class="d-flex justify-center justify-content-center align-items-center align-content-center"
                    style="min-width: 275px;"
                    v-if="data.schedules_after_midnight.length > 0"
                  >
                    <div style="width: 36%">
                      <hr />
                    </div>
                    <span
                      class="d-flex justify-center justify-content-center align-items-center align-content-center px-2 font-weight-light"
                      style="flex-direction: row;"
                    >
                      {{ allLanguageData.AfterMidnight }}
                    </span>
                    <div style="width: 36%">
                      <hr />
                    </div>
                  </div>

                  <li
                    class="list-inline-item time-tag"
                    :class="[schedule.showTime]"
                    v-for="(schedule, indexTime) in data.schedules_after_midnight"
                    :key="indexTime"
                    @click="seatLayoutShowBrij(schedule, data)"
                  >
                    <router-link to
                      >{{
                        moment(schedule.showTime, ['HH.mm'])
                          .locale(getCurrentLang().iso_2 || 'en')
                          .format('hh:mm A')
                      }}
                    </router-link>
                  </li>
                </ul>
                <!-- <div class="d-flex flex-wrap">
                  <div
                    class="time-tag"
                    v-for="(dataTime, indexTime) in data.show_time"
                    :key="indexTime"
                    @click="seatLayoutShow(dataTime, data)"
                  >
                    <router-link to class="text-white">{{
                      dataTime.time
                    }}</router-link>
                  </div>
                </div> -->
              </div>
            </div>
          </div>

          <div class="row emp-showtimes mx-0 mb-5 d-block d-md-none" v-if="gridView">
            <!-- <MovieSlider
              isShowTime="Yes"
              :key="componentKeySlider"
              bgcolor="emp-bgsecondary"
              oppbgcolor="emp-bgprimary"
              booknow="true"
              :moviesArray="movieGridData"
              @changeMviFilter="ChangeM($event)"
            /> -->
          </div>
          <hr class="showtime-line" />
        </div>
        <div v-if="allCinemas.length <= 0" class="no-shows-found">
          {{ isMovies }}
        </div>
      </div>
      <!--End Mobile View-->
    </div>
    <div class="contactcinema">
      <b-modal
        id="contactcinemapopup"
        :title="allLanguageData.Booking_info"
        hide-footer
      >
        <div class="">
          <h5
            style="color:#000000;font-weight:bold"
            :class="langName == 'ar' ? 'text-right' : ''"
          >
            {{ allLanguageData.ContactCinema }}
          </h5>
          <div
            class="d-flex flex-wrap"
            :class="langName == 'ar' ? 'justify-contentr-right' : ''"
          >
            <h5
              style="color:#000000;font-weight:bold"
              :class="langName == 'ar' ? 'ml-2' : ''"
            >
              {{ allLanguageData.Call_us }}:
            </h5>
            <a href="tel:07502100100"><span>07502100100</span></a>
            <span>/</span>
            <a href="tel:07502200200"><span>07502200200</span></a>

            <h5>{{ allLanguageData.to_book }}</h5>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import { makeRequest, makeRequestBrij } from '@/helper/internet.js'
import { mapState, mapGetters, mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import MovieSlider from '@/components/partials/movieSlider.vue'
import moment from 'moment'
import { URL_BASE } from '@/helper/constant.js'
import { LanguageService } from '../../services/storage.service'
export default {
  data () {
    return {
      URL_BASE: URL_BASE + '/',
      componentKeySlider: 0,
      showContent: false,
      offerId: null,
      listView: true,
      gridView: false,
      moviesLoading: false,
      bannerSlider: {
        arrows: false,
        dots: true,
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 2000,
      },
      dateSlider: {
        draggable: true,
        accessibility: false,
        slidesToShow: 7,
        arrows: true,
        dots: false,
        swipeToSlide: true,
        infinite: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 3,
            },
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
              adaptiveHeight: true,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
            },
          },
        ],

        // new
      },
      CategoryID: null,
      showAllDateList: [],
      tempAllShowData: [],
      allCinemas: [],
      movieGridData: [],
      finalSelectedDate: '',

      AllFormatsArray: [],
      cinemaList: [],
      SchID: '',
      showTerms: {
        Description: '',
        Title: '',
        rated: '',
        RatingImage: '',
      },
      filteredCinamaArray: [],
      MovieID: [],
      filteredExpArray: [],
      filteredMovieArray: [],
      selectedCinemaValues: [],
      selectedExpValues: [],
      selectedShowTimes: [],
      selectedMovie: [],
      filteredTimesArray: [],
      AllTimesArray: [],
      nowPlayingMovies: [],
      showTimeBanners: [],
      header: '',
      header1: '',
      description: '',
      refreshMovies: true,
      loadPageNo: 1,
      paginationCountdata: 0,
      isMovies: '',
      confirmedMovie: {
        status: true,
        message: 'Records Fetched',
        Records: { data: [], pagination: {} },
        VersionNameArray: [],
        sessions: [],
        MovieListArray: [{ CinemaList: [] }],
        MovieListArrayNew: [{ CinemaList: [] }],
        FormatArray: [],
        CinemaArray: [],
        LanguageArray: [],
        dateList: [],
        disable_date_list: [],
        isShowScreening: true,
        TypeList: [],
        FilterData: [],
      },
      // selectedDate: null,
      ss_id: null,
      md_id: null,
      screen_id: null,
      dateList: [],
      BrijScheduled: [],
      current_movie_ids: [],
      all_fetched_movie_ids: [],
      current_movies: [],
      all_fetched_movies: [],
      pagesList: [],
      bannerFromPagesCMS: [],
      gridMovies: [],
    }
  },
  beforeCreate: function () {
    document.body.className = 'light-section'
  },
  mounted () {
    // this.fetchCinemaList()
    // this.fetchMovieList()
    // this.fetchExperienceList();
  },
  beforeMount () {
    this.getConfirmedList()
    // this.showLoading();
    //  const { movieId, cat_id } = this.$route.params;
    // if (movieId && cat_id) {
    //   // this.MovieID = movieId.toString().split(",");

    //   // this.CategoryID = cat_id;

    // this.getShowTimeBanners()

    if (!this.headerCinemaId) {
      // this.getAllMovieDetails()
    }

    // } else {
    //   console.log(this.$route.params, "jitu");
    //   // this.$router.go(-1);
    // }

    this.getListOfPages()
    if (
      this.$store.getters.getSelectedBrijCinemas &&
      Object.keys(this.$store.getters.getSelectedBrijCinemas).length
    ) {
      this.selectedCinemaValues.push(this.$store.getters.getSelectedBrijCinemas)
    }
    let lang = LanguageService.getLanguage()
    let langName = 'eng'
    if (lang == null) {
      // langName = "eng";
      // window.location.pathname = "/landingpage"1;
    } else {
      langName = lang['lang']
    }
    this.langName = langName
  },

  beforeUpdate () {
    if (this.$refs.dateSlider) {
      this.$refs.dateSlider.destroy()
    }
    if (this.$refs.dateSlider2) {
      this.$refs.dateSlider2.destroy()
    }
    if (this.$refs.bannerSlider) {
      this.$refs.bannerSlider.destroy()
    }
  },
  updated () {
    this.$nextTick(function () {
      if (this.$refs.dateSlider) {
        this.$refs.dateSlider.create(this.slickOptions)
      }
      if (this.$refs.dateSlider2) {
        this.$refs.dateSlider2.create(this.dateSlider)
      }
    })
    this.$nextTick(function () {
      if (this.$refs.bannerSlider) {
        this.$refs.bannerSlider.create(this.bannerSlider)
      }
    })
  },
  computed: {
    headerCinemaId () {
      return this.$store.state.headerCinemaStore.headerCinemaId
    },
    bannersBrij () {
      return this.$store.getters.getBanners
    },

    filteredFlattenedSchedule () {
      let filtered = JSON.parse(JSON.stringify(this.BrijScheduled))

      let isAllCinemaSelected = this.selectedCinemaValues.some(c => c.cinema_id === '')
      let isAllMoviesSelected = this.selectedMovie.some(c => c.movie_id === '')
      let isAllFormatSelected = this.selectedExpValues.some(c => c.mf_id === '')
      let isAllSessionsSelected = this.selectedShowTimes.length === 4 // some(c => c.label === 'All')

      if (
        isAllCinemaSelected &&
        isAllFormatSelected &&
        isAllSessionsSelected &&
        isAllMoviesSelected
      ) {
        return filtered
      }

      if (isAllCinemaSelected) this.selectedCinemaValues = []
      if (isAllFormatSelected) this.selectedExpValues = []
      if (isAllSessionsSelected) this.selectedShowTimes = []
      if (
        isAllMoviesSelected ||
        this.selectedMovie.length === this.all_fetched_movies.length
      ) {
        this.selectedMovie = []
      }

      let cinema_ids = this.selectedCinemaValues.map(c => c.cinema_id).filter(x => !!x)
      let mf_ids = this.selectedExpValues.map(c => c.mf_id).filter(x => !!x)
      let sessions = this.selectedShowTimes.map(c => c.label).filter(x => !!x)
      let movie_ids = this.selectedMovie.map(c => c.movie_id).filter(x => !!x)

      filtered = filtered
        .filter(x => {
          if (isAllCinemaSelected || cinema_ids.length === 0) return true

          return cinema_ids.includes(x.cinema_id)
        })
        .filter(x => {
          if (
            isAllFormatSelected ||
            mf_ids.length === 0 ||
            x.schedules.length === 0 ||
            x.mf_ids.length === 0
          ) {
            return true
          }

          return x.mf_ids.some(x => mf_ids.includes(x))
        })
        .filter(x => {
          if (isAllMoviesSelected || movie_ids.length === 0) return true

          return movie_ids.includes(x.movie_ids[0])
        })
        .map(x => {
          if (sessions.length > 0) {
            x.schedules = x.schedules.filter(s => {
              if (
                sessions.includes('Morning') &&
                s.show_timing_label == 'Night' &&
                s.isPrevDayAmShow
              ) {
                return true
              }

              if (s.show_timing_label == 'Night') {
                return sessions.includes(s.show_timing_label) && !s.isPrevDayAmShow
              }

              return sessions.includes(s.show_timing_label)
            })

            x.schedules_after_midnight = x.schedules_after_midnight.filter(s =>
              sessions.includes(s.show_timing_label),
            )
          }

          return x
        })
        .sort((a, b) => {
          let comparison = a.cinema_id - b.cinema_id

          if (comparison === 0) {
            comparison = a.movie_ids[0] - b.movie_ids[0]
          }
          if (comparison === 0) {
            comparison = a.md_id - b.md_id
          }

          return comparison
        })
        .map(x => {
          x.schedules = x.schedules.sort((a, b) => {
            if (
              String(a.showTime).startsWith('0') &&
              String(b.showTime).startsWith('0') &&
              (String(a.show_timing_label).startsWith('Night') &&
                String(b.show_timing_label).startsWith('Night'))
            ) {
              return a.date_unix - b.date_unix
            } else if (
              (String(a.showTime).startsWith('0') ||
                String(b.showTime).startsWith('0')) &&
              (String(a.show_timing_label).startsWith('Night') ||
                String(b.show_timing_label).startsWith('Night'))
            ) {
              return b.date_unix - a.date_unix
            } else {
              return a.date_unix - b.date_unix
            }
          })

          x.schedules_after_midnight = x.schedules_after_midnight.sort((a, b) => {
            if (
              String(a.showTime).startsWith('0') &&
              String(b.showTime).startsWith('0') &&
              (String(a.show_timing_label).startsWith('Night') &&
                String(b.show_timing_label).startsWith('Night'))
            ) {
              return a.date_unix - b.date_unix
            } else if (
              (String(a.showTime).startsWith('0') ||
                String(b.showTime).startsWith('0')) &&
              (String(a.show_timing_label).startsWith('Night') ||
                String(b.show_timing_label).startsWith('Night'))
            ) {
              return b.date_unix - a.date_unix
            } else {
              return a.date_unix - b.date_unix
            }
          })

          return x
        })

      this.gridMovies = filtered.filter(x => x.schedules.length > 0)
      return filtered.filter(x => x.schedules.length > 0)
    },
    filteredMovies () {
      this.moviesLoading = true
      let filtered = JSON.parse(JSON.stringify(this.BrijScheduled))

      let isAllCinemaSelected = this.selectedCinemaValues.some(c => c.cinema_id === '')
      let isAllMoviesSelected = this.selectedMovie.some(c => c.movie_id === '')
      let isAllFormatSelected = this.selectedExpValues.some(c => c.mf_id === '')
      let isAllSessionsSelected = this.selectedShowTimes.length === 4 // some(c => c.label === 'All')

      if (
        isAllCinemaSelected &&
        isAllFormatSelected &&
        isAllSessionsSelected &&
        isAllMoviesSelected
      ) {
        return filtered
      }

      if (isAllCinemaSelected) this.selectedCinemaValues = []
      if (isAllFormatSelected) this.selectedExpValues = []
      if (isAllSessionsSelected) this.selectedShowTimes = []
      if (
        isAllMoviesSelected ||
        this.selectedMovie.length === this.all_fetched_movies.length
      ) {
        this.selectedMovie = []
      }

      let cinema_ids = this.selectedCinemaValues.map(c => c.cinema_id).filter(x => !!x)
      let mf_ids = this.selectedExpValues.map(c => c.mf_id).filter(x => !!x)
      let sessions = this.selectedShowTimes.map(c => c.label).filter(x => !!x)
      let movie_ids = this.selectedMovie.map(c => c.movie_id).filter(x => !!x)

      filtered = filtered
        .filter(x => {
          if (isAllCinemaSelected || cinema_ids.length === 0) return true

          return cinema_ids.includes(x.cinema_id)
        })
        .filter(x => {
          if (
            isAllFormatSelected ||
            mf_ids.length === 0 ||
            x.schedules.length === 0 ||
            x.mf_ids.length === 0
          ) {
            return true
          }

          return x.mf_ids.some(x => mf_ids.includes(x))
        })
        .filter(x => {
          if (isAllMoviesSelected || movie_ids.length === 0) return true

          return movie_ids.includes(x.movie_ids[0])
        })
        .map(x => {
          if (sessions.length > 0) {
            x.schedules = x.schedules.filter(s => {
              if (
                sessions.includes('Morning') &&
                s.show_timing_label == 'Night' &&
                s.isPrevDayAmShow
              ) {
                return true
              }

              if (s.show_timing_label == 'Night') {
                return sessions.includes(s.show_timing_label) && !s.isPrevDayAmShow
              }

              return sessions.includes(s.show_timing_label)
            })

            x.schedules_after_midnight = x.schedules_after_midnight.filter(s =>
              sessions.includes(s.show_timing_label),
            )
          }

          return x
        })
        .sort((a, b) => {
          let comparison = a.cinema_id - b.cinema_id

          if (comparison === 0) {
            comparison = a.movie_ids[0] - b.movie_ids[0]
          }
          if (comparison === 0) {
            comparison = a.md_id - b.md_id
          }

          return comparison
        })
        .map(x => {
          x.schedules = x.schedules.sort((a, b) => {
            if (
              String(a.showTime).startsWith('0') &&
              String(b.showTime).startsWith('0') &&
              (String(a.show_timing_label).startsWith('Night') &&
                String(b.show_timing_label).startsWith('Night'))
            ) {
              return a.date_unix - b.date_unix
            } else if (
              (String(a.showTime).startsWith('0') ||
                String(b.showTime).startsWith('0')) &&
              (String(a.show_timing_label).startsWith('Night') ||
                String(b.show_timing_label).startsWith('Night'))
            ) {
              return b.date_unix - a.date_unix
            } else {
              return a.date_unix - b.date_unix
            }
          })

          x.schedules_after_midnight = x.schedules_after_midnight.sort((a, b) => {
            if (
              String(a.showTime).startsWith('0') &&
              String(b.showTime).startsWith('0') &&
              (String(a.show_timing_label).startsWith('Night') &&
                String(b.show_timing_label).startsWith('Night'))
            ) {
              return a.date_unix - b.date_unix
            } else if (
              (String(a.showTime).startsWith('0') ||
                String(b.showTime).startsWith('0')) &&
              (String(a.show_timing_label).startsWith('Night') ||
                String(b.show_timing_label).startsWith('Night'))
            ) {
              return b.date_unix - a.date_unix
            } else {
              return a.date_unix - b.date_unix
            }
          })

          return x
        })
        .filter(x => x.schedules.length > 0)

      this.$forceUpdate()
      this.$nextTick(() => {
        this.moviesLoading = false
        this.componentKeySlider = this.componentKeySlider + 1
      })

      return [
        ...new Map(
          filtered
            .map(x => ({ ...x, ...x.movie }))
            .map(item => [item['movie_id'], item]),
        ).values(),
      ]
    },
  },
  components: {
    Multiselect,
    MovieSlider,
  },
  watch: {
    headerCinemaId: {
      handler: function (newVal, oldVal) {
        this.refreshMovies = true
        this.loadPageNo = 1
        this.gridView = false
        this.listView = true
        this.selectedCinemaValues = []

        let obj = this.cinemaList.filter(y => {
          return y.CinemaID == this.headerCinemaId
        })
        if (obj.length > 0) {
          this.selectedCinemaValues.push(...obj)
        }

        // if (obj.length > 0) {
        //   this.filteredCinamaArray = [];

        // }
        // this.filteredCinamaArray = [];
        // this.finalSelectedDate = "";
        // this.filteredCinamaArray.push(this.headerCinemaId);
        // this.getAllMovieDetails();
      },
      deep: true,
    },
  },

  methods: {
    getCinemaTranslatedName (cinema) {
      if (!cinema) return ''

      let name =
        this.getLangSpecificAttribute(
          cinema.translation_data || [],
          this.getCurrentLang().brij_lang_id,
          'cinema_name',
          'langaugeId',
        ) || cinema.cinema_name
      return name
    },
    moment,
    getMovieGrid () {
      return [
        ...new Map(
          this.BrijScheduled.map(x => ({ ...x, ...x.movie })).map(item => [
            item['movie_id'],
            item,
          ]),
        ).values(),
      ]
    },
    getMovieData (schedule, type = 'movie_title') {
      let data = ''

      let movie_id = schedule.movie_ids[0]
      let movie = this.all_fetched_movies.filter(x => x.movie_id == movie_id)[0] || {}

      switch (type) {
        case 'movie_title':
          data = movie.movie_title
          break

        case 'artwork':
          data = movie.artwork
          break

        default:
          break
      }

      return data
    },

    async getAllMovieDetailsBrij (movie_id) {
      if (!movie_id) return Promise.resolve({})

      return makeRequestBrij(`/api/cinema/movie-detail/${movie_id}/1/`, 'GET', null, {
        user_lang_id: 1,
      })
        .then(response => {
          const { error, res } = response
          if (error) return {}

          return res.data.Records[0] || {}
        })
        .catch(error => {
          console.log(`error fetching movie ${movie_id}`, error)
          return {}
        })
    },
    getConfirmedList (fromDate = null) {
      this.moviesLoading = true
      this.showLoading()

      // if (fromDate) this.showLoading()
      let payload = {
        limit: 1000,
      }
      if (fromDate && moment(fromDate).isValid()) {
        payload.fromDate = moment(fromDate).format('YYYY-MM-DD')
      }

      if (
        this.$store.getters.getSelectedBrijCinemas &&
        Object.keys(this.$store.getters.getSelectedBrijCinemas).length
      ) {
        payload.cinema_id = this.$store.getters.getSelectedBrijCinemas.cinema_id
      }

      var timer = -performance.now()
      makeRequestBrij(
        `/api/cinema/admin/movie-confirmed-list-all`,
        'GET',
        null,
        payload,
      )
        .then(response => {
          const { error, res } = response

          if (res.data.status) {
            this.confirmedMovie = res.data

            if (!this.finalSelectedDate) {
              this.dateList = response.res.data.dateList

              if (this.dateList.length > 1) {
                let x = this.dateList[this.dateList.length - 1];

                [1, 2, 3, 4, 5, 6, 7, 8, 9].forEach(d => {
                  if (this.dateList.length < 7) {
                    this.dateList.push({
                      ss_actual_start_date: moment(x.ss_actual_start_date)
                        .add(d, 'day')
                        .format('YYYY-MM-DD'),
                      day: moment(x.ss_actual_start_date)
                        .add(d, 'day')
                        .format('DD'),
                      Month: moment(x.ss_actual_start_date)
                        .add(d, 'day')
                        .format('MM'),
                      dayName: moment(x.ss_actual_start_date)
                        .add(d, 'day')
                        .format('dddd'),
                      momthName: moment(x.ss_actual_start_date)
                        .add(d, 'day')
                        .format('MMM'),
                    })
                  }
                })
                this.$forceUpdate()
              }
            }

            let confirmedMovie = res.data
            let flattenSchedule = []
            let flattenScheduleEntries = null
            let flattenSchedulegroupByToMap = null

            confirmedMovie.MovieListArrayNew.forEach(m => {
              m.CinemaList.forEach(c => {
                let { format_list = [], ...cinema } = c

                format_list.forEach(f => {
                  let { screens = [], ...movieversion } = f

                  screens.forEach(scr => {
                    let {
                      schedule_list = [],
                      midnight_schedule_array = [],
                      ...screen
                    } = scr

                    schedule_list.forEach(sh => {
                      flattenSchedule.push({
                        ...cinema,
                        ...movieversion,
                        ...screen,
                        cinema,
                        movieversion,
                        screen,
                        ...sh,
                        isAfterMidnight: false,
                      })
                    })

                    midnight_schedule_array.forEach(sh => {
                      flattenSchedule.push({
                        ...cinema,
                        ...movieversion,
                        ...screen,
                        cinema,
                        movieversion,
                        screen,
                        ...sh,
                        isAfterMidnight: true,
                      })
                    })
                  })
                })
              })
            })

            flattenSchedulegroupByToMap = new Map(
              this.groupByToMap(flattenSchedule, x =>
                JSON.stringify({ cinema_id: x.cinema_id, md_id: x.md_id }),
              ),
            )
            // flattenScheduleEntries = new Map(this.groupByToMap(flattenSchedule, x => (JSON.stringify({cinema_id: x.cinema_id, md_id: x.md_id})))).entries()

            let groupedShowsByMd = []
            for (const [key, value] of flattenSchedulegroupByToMap) {
              let cinema = JSON.parse(String(key))
              let shows = [...value]

              // shows.forEach((ss) => {
              // ss.isPrevDayAmShow = moment(ss.showTime, ['HH.mm'])
              //   .locale('en')
              //   .format('hh:mm A')
              //   .toLowerCase()
              //   .includes('am')
              // })
              groupedShowsByMd.push({
                ...cinema,
                schedules: shows.filter(x => !x.isAfterMidnight),
                schedules_after_midnight: shows.filter(x => x.isAfterMidnight),
              })
            }

            groupedShowsByMd.map(x => {
              x.mf_names = [...new Set(x.schedules.map(m => m.mf_name))]
                .filter(x => !!x)
                .join(',')
              x.mf_ids = [...new Set(x.schedules.map(m => m.mf_id))].filter(x => !!x)
              x.movie_ids = [...new Set(x.schedules.map(m => m.movie_id))].filter(
                x => !!x,
              )
              return x
            })

            // console.log({
            //   flattenSchedule,
            //   flattenSchedulegroupByToMap,
            //   flattenScheduleEntries,
            //   groupedShowsByMd
            // })

            this.BrijScheduled = groupedShowsByMd

            this.current_movie_ids = [
              ...new Set(
                groupedShowsByMd.flatMap(s => s.schedules.map(s => s.movie_id)),
              ),
            ]
          }

          this.$forceUpdate()
          return { res, groupedShowsByMd: this.BrijScheduled }
        })
        .then(data => {
          // get next days am show, dont wait for this promise
          /*
          let payload = {
            limit: 1000,
          }

          if (fromDate && moment(fromDate).isValid()) {
            payload.fromDate = moment(fromDate)
              .add("1", "d")
              .format("YYYY-MM-DD");
          } else {
            payload.fromDate = moment()
              .add("1", "d")
              .format("YYYY-MM-DD");
          }

          if (
            this.$store.getters.getSelectedBrijCinemas &&
          Object.keys(this.$store.getters.getSelectedBrijCinemas).length
          ) {
            payload.cinema_id = this.$store.getters.getSelectedBrijCinemas.cinema_id;
          }

          makeRequestBrij(
            `/api/cinema/admin/movie-confirmed-list-all`,
            "GET",
            null,
            payload
          ).then((response) => {
            const {error, res} = response;

            if (res.data.status) {
              let confirmedMovie = res.data;
              let flattenSchedule = [];
              let flattenSchedulegroupByToMap = null;

              confirmedMovie.MovieListArrayNew.forEach((m) => {
                m.CinemaList.forEach((c) => {
                  let {format_list = [], ...cinema} = c;

                  format_list.forEach((f) => {
                    let {screens = [], ...movieversion} = f;

                    screens.forEach((scr) => {
                      let {schedule_list = [], ...screen} = scr;

                      schedule_list.forEach((sh) => {
                        flattenSchedule.push({
                          ...cinema,
                          ...movieversion,
                          ...screen,
                          cinema,
                          movieversion,
                          screen,
                          ...sh,
                        });
                      });
                    });
                  });
                });
              });

              flattenSchedulegroupByToMap = new Map(
                this.groupByToMap(flattenSchedule, (x) =>
                  JSON.stringify({ cinema_id: x.cinema_id, md_id: x.md_id })
                )
              );

              let groupedShowsByMd = [];
              for (const [key, value] of flattenSchedulegroupByToMap) {
                let cinema = JSON.parse(String(key));
                let shows = [...value];

                shows.forEach((ss) => {
                  let time = moment(ss.showTime, ["HH.mm"])
                    .locale("en")
                    .format("hh:mm A")
                    .toLowerCase();

                  ss.isNextDayAmShow =
                    time.includes("am") &&
                    (time.startsWith("12") ||
                      time.startsWith("01") ||
                      time.startsWith("02") ||
                      time.startsWith("03") ||
                      time.startsWith("04") ||
                      time.startsWith("05"));
                });

                groupedShowsByMd.push({
                  ...cinema,
                  schedules: shows,
                  schedules_after_midnight: [],
                });
              }

              groupedShowsByMd.map((x) => {
                x.mf_names = [...new Set(x.schedules.map((m) => m.mf_name))]
                  .filter((x) => !!x)
                  .join(",");
                x.mf_ids = [...new Set(x.schedules.map((m) => m.mf_id))].filter(
                  (x) => !!x
                );
                x.movie_ids = [
                  ...new Set(x.schedules.map((m) => m.movie_id)),
                ].filter((x) => !!x);
                return x;
              });

              // console.log({
              //   flattenSchedule,
              //   flattenSchedulegroupByToMap,
              //   flattenScheduleEntries,
              //   groupedShowsByMd
              // })

              let BrijScheduled = groupedShowsByMd;

                this.BrijScheduled.forEach(todays => {
                  BrijScheduled.forEach(tomorrows => {
                    if (
                      todays.cinema_id === tomorrows.cinema_id &&
                      todays.md_id === tomorrows.md_id
                    ) {
                      todays.schedules_after_midnight = tomorrows.schedules.filter(x => x.isNextDayAmShow)
                    }
                  })
                })
              }
            })
          */
          return Promise.resolve(data)
        })
        .then(({ res, groupedShowsByMd }) => {
          let filteredCurrentMovieIds = [
            ...new Set([...this.all_fetched_movie_ids, ...this.current_movie_ids]),
          ].filter(x => {
            if (this.all_fetched_movie_ids.length === 0) return true

            return !this.all_fetched_movie_ids.includes(x)
          })

          return Promise.all(
            filteredCurrentMovieIds.map(x =>
              this.getAllMovieDetailsBrij(x).then(m => ({
                movie_id: x,
                movie: m,
                ...m,
              })),
            ),
          )
        })
        .then(allMovies => {
          allMovies.forEach(m => {
            m.movie_title =
              this.getLangSpecificAttribute(
                m.altMovieContent,
                this.getCurrentLang().brij_lang_id,
                'mc_title',
              ) ||
              m.movie_title ||
              m.original_title_of_movie

            m.mc_plot =
              this.getLangSpecificAttribute(
                m.altMovieContent,
                this.getCurrentLang().brij_lang_id,
                'mc_plot',
              ) || m.mc_plot

            m.artwork = this.checkBaseUrl(
              this.getLangSpecificAttribute(
                m.altMovieContent,
                this.getCurrentLang().brij_lang_id,
                'artwork',
              ) || m.artwork,
            )

            //
          })

          this.current_movies = allMovies

          this.all_fetched_movie_ids = [
            ...new Set([...this.all_fetched_movie_ids, ...this.current_movie_ids]),
          ]
          this.all_fetched_movies = [
            ...this.all_fetched_movies,
            ...this.current_movies,
          ]

          this.$forceUpdate()
          return allMovies
        })
        .then(() => {
          this.BrijScheduled.forEach(s => {
            let movie_id = s.movie_ids[0]
            let movie = this.all_fetched_movies.filter(x => x.movie_id == movie_id)[0]
            s.movie = movie || {}
          })
          this.$forceUpdate()
        })
        .catch(error => {
          if (!this.finalSelectedDate) {
            this.dateList = []
          }
          console.log('Error', error)
        })
        .finally(() => {
          this.hideLoading()
          this.moviesLoading = false

          timer += performance.now()
          console.log(`getConfirmedList Time: ${(timer / 1000).toFixed(5)} sec`)
        })
    },
    onLoadMore () {
      this.refreshMovies = false
      this.loadPageNo = this.loadPageNo + 1
      this.getAllMovieDetails()
    },
    scheduleDateMovie (showDate, id) {
      this.finalSelectedDate = showDate
      if (id == '1') {
        this.loadPageNo = 1
        this.refreshMovies = true
      }

      this.getConfirmedList(showDate)
    },
    next () {
      this.$refs.bannerSlider.next()
    },

    prev () {
      this.$refs.bannerSlider.prev()
    },

    reInit () {},
    ChangeM (mviId) {
      this.selectedMovie = []
      this.gridView = false
      let arry = this.nowPlayingMovies.filter(p => {
        return p.movie_id == mviId
      })
      if (arry.length > 0) {
        this.selectedMovie = arry
      }
      this.listView = true
    },
    seatLayoutShow (data, dataShowTerms) {
      if (
        this.CountryID == 102 ||
        this.CountryID == '102' ||
        this.CountryID == 119 ||
        this.CountryID == '119'
      ) {
        this.$refs['bookScreen'].show()
        return false
      }
      console.log(data)
      this.SchID = data.SchID
      if (
        dataShowTerms &&
        dataShowTerms.ShowTerms &&
        dataShowTerms.ShowTerms.length > 0
      ) {
        this.showTerms.Title = dataShowTerms.ShowTerms[0].Title
        this.showTerms.Description = dataShowTerms.ShowTerms[0].Description
        this.showTerms.rated = dataShowTerms.ShowTerms[0].rated
        this.showTerms.RatingImage = dataShowTerms.ShowTerms[0].RatingImage
        this.ShowTermsPopup()
      } else {
        this.$router.push({
          path: '/seatLayout/' + data.SchID,
        })
      }
      // this.$router.push({
      //   path: "/seatLayout/" + data.SchID
      // });
    },
    seatLayoutShowBrij (schedule, data) {
      console.log({ schedule, data })
      if (
        this.CountryID == 102 ||
        this.CountryID == '102' ||
        this.CountryID == 119 ||
        this.CountryID == '119'
      ) {
        this.$refs['bookScreen'].show()
        return false
      }

      this.ss_id = schedule.ss_id
      this.md_id = schedule.md_id
      this.screen_id = schedule.screen_id

      // this.showTerms.RatingImage = 'https://apinew.empirecinemas.com//assets/images/Support/61446b8aaafbe.jpg'
      // this.showTerms.Description = '<p>I understand this movie is rated R18. </p><p>No one below the age of 18 will be permitted.</p><p>You must show your I.D.</p><p><strong>Food &amp; drinks from outside are not allowed in the cinema.</strong></p>'
      // this.showTerms.rated = 'R18'
      // this.showTerms.Title = 'The following content is prohibited for viewers below the age of 18'

      let rating_id = this.all_fetched_movies.filter(
        m => m.movie_id == schedule.movie_id,
      ).length
        ? this.all_fetched_movies.filter(m => m.movie_id == schedule.movie_id)[0]
          .rating_id
        : null
      if (rating_id) {
        makeRequestBrij(`/rating_popup/?rating_id=${rating_id}`, 'GET', null, null)
          .then(response => {
            const { res } = response
            if (res && res.data && res.data.Records && res.data.Records.length > 0) {
              const popData = res.data.Records.filter(
                p => p.pp_lang_id == this.getCurrentLang().brij_lang_id,
              ).length
                ? res.data.Records.filter(
                  p => p.pp_lang_id == this.getCurrentLang().brij_lang_id,
                )[0]
                : res.data.Records[0]
              console.log(popData)
              this.showTerms.RatingImage = popData.pp_banner
              this.showTerms.Description = popData.pp_description
              this.showTerms.rated = popData.rating_name
              this.showTerms.Title = popData.pp_title
            }
          })
          .catch(err => {
            console.log(err)
          })
      }

      this.ShowTermsPopup()
    },
    onClickAgree () {
      // this.$router.push({
      //   path: '/seatLayout/' + this.SchID,
      // })
      this.$router.push({
        path: `/seatLayout/${this.ss_id}/${this.md_id}/${this.screen_id}`,
      })
    },
    ShowTermsPopup () {
      this.$nextTick(() => {
        this.$refs['ruleOfCountryForShows'].show()
      })
    },
    HideTermsPopup () {
      this.$refs['ruleOfCountryForShows'].hide()
    },
    getShowTimeBanners () {
      // this.hideLoading();

      let payload = {
        PageName: 'showtime',
      }

      makeRequest('/PageData/', 'POST', null, payload)
        .then(response => {
          const { error, res } = response // console.log("Show details", res);

          // this.hideLoading();

          if (res.data.hasOwnProperty('banner') && res.data.banner.length > 0) {
            this.showTimeBanners = res.data.banner
          }

          if (res.data.hasOwnProperty('data') && res.data.data.length > 0) {
            this.header = res.data.data[0].header
            this.header1 = res.data.data[0].header1
            this.description = res.data.data[0].description
          }

          // this.hideLoading();
          console.log('jitu')
        })
        .catch(error => {
          // this.hideLoading();
          console.log('Error', error)
        })
    },
    getAllMovieDetails: function (movieIdValue, cat_id) {
      this.isMovies = ''
      this.componentKeySlider += 1
      return false
      // this.showLoading()
      let payload = {
        MovieID: this.MovieID,
        CategoryID: '1',
        CinemaID: this.filteredCinamaArray,
        Format: this.filteredExpArray,
        ShowTimes: this.filteredTimesArray,
        MovieID: this.filteredMovieArray,
        pageNo: this.loadPageNo,
        // ShowDate: "2021-09-02"
      }
      if (this.finalSelectedDate) {
        payload['ShowDate'] = this.finalSelectedDate ? this.finalSelectedDate : ''
      }
      this.tempAllShowData = []
      if (this.refreshMovies == true) {
        this.allCinemas = []
      }
      if (this.finalSelectedDate) {
      } else {
        this.showAllDateList = []
      }

      makeRequest('/GetShowtimesByMovie/', 'POST', null, payload)
        .then(response => {
          const { error, res } = response // console.log("Show details", res);
          if (res.data.Status && res.data.AllShowdates.length > 0) {
            this.hideLoading()

            if (res.data.hasOwnProperty('MovieData') && res.data.MovieData.length > 0) {
              this.tempAllShowData = res.data.MovieData
              // if (
              //   this.tempAllShowData.length > 0 &&
              //   this.tempAllShowData[0].Showdates.length > 0
              // ) {
              //   this.paginationCountdata = this.tempAllShowData[0].Showdates[0].TotalpageData[0].Totalpages;
              // }
            } else {
            }
            if (res.data.hasOwnProperty('TotalpageData')) {
              this.paginationCountdata = res.data.TotalpageData.Totalpages
            }
            if (this.finalSelectedDate) {
              this.scheduleDate(this.finalSelectedDate)
            } else {
              if (
                res.data.hasOwnProperty('AllShowdates') &&
                res.data.AllShowdates.length > 0
              ) {
                this.showAllDateList = res.data.AllShowdates
                this.scheduleDate(this.showAllDateList[0].showdate)
                if (
                  res.data.hasOwnProperty('AllTimes') &&
                  res.data.AllTimes.length > 0
                ) {
                  this.AllTimesArray = res.data.AllTimes
                  let objMviAll = {
                    title: 'ALL TIMINGS',
                    ID: 'ALL',
                  }

                  this.AllTimesArray.unshift(objMviAll)
                }
              }
              if (
                res.data.hasOwnProperty('AllFormats') &&
                res.data.AllFormats.length > 0
              ) {
                this.AllFormatsArray = res.data.AllFormatsNew
                let objMviAll = {
                  Metascore: 'ALL FORMATS',
                  MetascoreID: 'ALL',
                }

                this.AllFormatsArray.unshift(objMviAll)
              }
            }
          } else {
            this.isMovies = 'NO SHOWS FOUND'
          }

          this.hideLoading()
        })
        .catch(error => {
          this.hideLoading()
          console.log('Error', error)
        })
    },
    scheduleDate: function (showDate) {
      if (this.refreshMovies == true) {
        this.allCinemas = []
      }
      this.componentKeySlider += 1
      this.showLoading()

      try {
        this.finalSelectedDate = showDate
        if (this.tempAllShowData.length > 0) {
          for (let p = 0; p < this.tempAllShowData.length; p++) {
            let selectedDateShowTimes = this.tempAllShowData[p].Showdates.filter(x => {
              return x.showdate == showDate
            })

            if (selectedDateShowTimes.length > 0) {
              for (let q = 0; q < selectedDateShowTimes.length; q++) {
                this.allCinemas.push(...selectedDateShowTimes[q].times)
              }
            }
          }
        }

        if (this.allCinemas.length <= 0) {
          this.isMovies = 'NO SHOWS FOUND'
        }
        this.movieGridData = []
        const key = 'movie_name'

        const arrayUniqueByKey = [
          ...new Map(this.allCinemas.map(item => [item[key], item])).values(),
        ]

        if (arrayUniqueByKey.length > 0) {
          for (let t = 0; t < arrayUniqueByKey.length; t++) {
            let getSliderMovie = this.nowPlayingMovies.filter(p => {
              return p.movie_title == arrayUniqueByKey[t].movie_name
            })
            if (getSliderMovie.length > 0) {
              this.movieGridData.push(...getSliderMovie)
            }
          }
        }

        setTimeout(() => {
          this.hideLoading()
        }, 500)
      } catch (error) {
        console.log('error', error)
      }
      // if (showDate) {
      //   this.showLoading();
      // }
      // this.showLoading();
    },
    fetchMovieList: function (value) {
      this.nowPlayingMovies = []
      let payload = {
        CategoryID: '1',
        // CinemaID: this.headerCinemaId ? this.headerCinemaId : ""
      }
      makeRequest('/GetDataByCategory/', 'POST', null, payload)
        .then(response => {
          const { error, res } = response
          if (res.data.hasOwnProperty('Shows') && res.data.Shows.length > 0) {
            this.nowPlayingMovies = res.data.Shows[0].show
            let objMviAll = {
              movie_title: 'ALL MOVIES',
              movie_id: 'ALL',
            }

            this.nowPlayingMovies.unshift(objMviAll)
          }
        })
        .catch(error => {
          console.log('Error', error)
        })
    },
    // fetchCinemaList: function () {
    //   this.cinemaList = []
    //   makeRequest('/GetCinemas', 'POST', null, null)
    //     .then(result => {
    //       const { error, res } = result
    //       const { data } = res.data
    //       if (res.data) {
    //         this.cinemaList = res.data.Categories
    //       }
    //       let objcinemaAll = {
    //         CinemaName: this.allLanguageData.AllCinemas,
    //         CinemaID: 'ALL',
    //       }
    //
    //       this.cinemaList.unshift(objcinemaAll)
    //
    //       let obj = this.cinemaList.filter(y => {
    //         return y.CinemaID == this.headerCinemaId
    //       })
    //       if (obj.length > 0) {
    //         this.selectedCinemaValues.push(...obj)
    //       }
    //     })
    //
    //     .catch(error => {
    //       console.log('Error on vue front', error)
    //     })
    // },
    // fetchExperienceList: function() {
    //   makeRequest("/GetExperience", "POST", null, null)
    //     .then(result => {
    //       const { error, res } = result;
    //       const { data } = res.data;
    //       if (res.data) {
    //         this.AllFormatsArray = res.data.Categories;
    //       }
    //     })
    //     .catch(error => {
    //       console.log("Error on vue front", error);
    //     });
    // },
    showView: function (data) {
      // this.showLoading();
      this.getAllMovieDetails()
      if (data == 'grid') {
        (this.gridView = true), (this.listView = false)
      } else {
        (this.gridView = false), (this.listView = true)
      }
      // setTimeout(() => {
      //   this.hideLoading();
      // }, 500);
    },
    getOfferId: function (index) {
      this.offerId = index
      this.checkOfferId(index)
      // console.log(index);
    },
    checkOfferId: function (index) {
      console.log(index)
      if (index == this.offerId) {
        console.log('ruchi')
        this.showContent = true
        return true
      }
    },
    getListOfPages () {
      const pagesFunction = async () => {
        try {
          let payload = {
            mpm_name: 'showTimes',
            mpm_lang_id: this.getCurrentLang().brij_lang_id,
          }
          let response = await makeRequestBrij(
            `/api/admin/list-of-pages?mpm_name=${payload.mpm_name}&mpm_lang_id=${
              payload.mpm_lang_id
            }`,
            'GET',
            null,
            null,
          )
          const { error, res } = response

          if (res.data.status) {
            let { data } = res
            let records = data.Records
            let newRecords = []
            records.map((x, index) => {
              let get_index = newRecords.findIndex(y => {
                return y.main_name == x.mpm_name
              })
              console.log({ get_index })
              if (get_index < 0) {
                let obj = {
                  mpm_id: x.mpm_id,
                  main_name: x.mpm_name,
                  lang_id: x.mpm_lang_id,
                  banner: x.mpm_banner,
                  status: x.is_active,
                  otherData: [
                    {
                      mpm_d_id: x.mpm_d_id,
                      main_name: x.mpm_d_main_name,
                      header_name: x.mpm_d_header_name,
                      description: x.mpm_d_description,
                      images: x.mpm_d_images,
                      cover_image: x.mpm_d_cover_image,
                      o_status: x.mpm_d_is_active,
                    },
                  ],
                }
                newRecords.push(obj)
              } else {
                let obj = {
                  mpm_d_id: x.mpm_d_id,
                  main_name: x.mpm_d_main_name,
                  header_name: x.mpm_d_header_name,
                  description: x.mpm_d_description,
                  images: x.mpm_d_images,
                  cover_image: x.mpm_d_cover_image,
                  o_status: x.mpm_d_is_active,
                }
                newRecords[get_index].otherData.push(obj)
              }
            })
            console.log('newRecords', newRecords)
            this.pagesList = newRecords
            let otherData = this.getSafe(() => this.pagesList[0].otherData[0], {})
            this.bannerFromPagesCMS = this.getSafe(() => this.pagesList[0], {
              banner: '',
            }).banner.split(',')

            this.header = otherData.main_name
            this.header1 = otherData.header_name
            this.description = otherData.description
          }
        } catch (error) {
          console.log('getPagesList', { error })
        }
      }
      pagesFunction()
    },
  },
}
</script>
<style>
#bookScreen .close {
  margin-top: -7px;
  margin-right: -10px;
}

#bookScreen .modal-body {
  background: white !important;
  color: black;
}

#bookScreen .modal-title {
  color: black !important;
  margin: initial !important;
}

#bookScreen .emp_new_modal_body {
  color: black !important;
}

.no-shows-found {
  background: #e5e6e7;
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/allCinemashowtimes.vue